module.exports = __webpack_public_path__ + "img/ens-sec.7312d3ec.jpg";